module.exports = __webpack_public_path__ + "img/rightclick.d760cfcf.gif";